import * as MuiStepper from '@mui/material/Stepper'
import React from 'react'

export type StepperProps = MuiStepper.StepperProps

export function Stepper({ children, ...props }: StepperProps) {
  return <MuiStepper.default {...props}>{children}</MuiStepper.default>
}
